import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent implements AfterViewInit {
  @ViewChild(SidebarComponent) sidebarComponent!: SidebarComponent;
  currentUrl: string = '';
  
  constructor(private router: Router) {
    this.currentUrl = this.router.url;
    
    // Subscribe to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentUrl = event.url;
    });
  }
  
  ngAfterViewInit() {
    // Component is ready
  }
  
  get isSidebarExpanded(): boolean {
    return this.sidebarComponent ? this.sidebarComponent.expandSidebar : false;
  }
  
  get shouldRemovePadding(): boolean {
    return this.currentUrl.includes('/chats') || 
           this.currentUrl.includes('/?') || 
           this.currentUrl === '/';
  }
}